/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 *
 * https://github.com/zalando-lounge/modules/blob/master/packages/abtesting/README.md#cli
 */

import { AssignmentType, createConfig } from '@pegasus/abtesting';

export const { apiPrefix, pendingAssignments, timeout } = createConfig({
    apiPrefix: '/mylounge-api',
    pendingAssignments: [
        {
            // GBS - Reduce Confusion Desktop Web
            alias: 'ccf-reduce-confusion-desktop-web',
            id: 'a6a4bd5c-14f9-4094-ba7a-78f710f65456',
            defaultVariant: 'control_ccf_entry_reduce_confusion_desktop',
            variants: [
                'control_ccf_entry_reduce_confusion_desktop',
                'variant_ccf_entry_reduce_confusion_desktop',
            ],
            type: AssignmentType.SERVER,
            forced: 'variant_ccf_entry_reduce_confusion_desktop',
        },
        {
            // Search at Lounge
            alias: 'lounge_enable_search_feature',
            id: '27503c2c-c293-4a40-9d77-e3895697b1c6',
            defaultVariant: 'control_search_off',
            variants: [
                'control_search_off',
                'variant_search_on',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Activate | New Deals Today | Daily Engaged Users
            alias: 'new_deals_today',
            id: '65d24b19-49ef-468c-999d-37e8f50f3a1c',
            defaultVariant: 'control_disable_new_deals',
            variants: [
                'control_disable_new_deals',
                'variant_enable_new_deals',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Convert - Keep article in cart
            alias: 'convert-keep-article-in-cart',
            id: '2016e0eb-a785-4cdd-8914-2d508d680e3d',
            defaultVariant: 'control_keep_article_cart',
            variants: [
                'control_keep_article_cart',
                'variant_keep_article_cart',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Activate | New Deals Today | Leaped Users
            alias: 'new_deals_leaped',
            id: 'd1305ff6-86d7-4681-8fb5-1e742e290088',
            defaultVariant: 'control_disable_new_deals',
            variants: [
                'control_disable_new_deals',
                'variant_enable_new_deals',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Discover - SAC New UI
            alias: 'sac-new-ui',
            id: '0feecbbd-2ed5-4694-9c2d-23fe0b8e314b',
            defaultVariant: 'control_sac',
            variants: [
                'control_sac',
                'variant_sac_new',
            ],
            type: AssignmentType.SERVER,
        },
        {
            // Activate | Continue Where You Left Off
            alias: 'activate_continue_where_you_left',
            id: 'ab13d177-f2a7-4196-ade5-02c1a28216ad',
            defaultVariant: 'control_disable_continue_shop',
            variants: [
                'control_disable_continue_shop',
                'variant_enable_continue_shop',
            ],
            type: AssignmentType.PRE_ASSIGNMENT,
        },
    ],
    timeout: 200,
});
